module.exports = __webpack_public_path__ + "img/419.88b45fc0.jpg";